import { getSessionStorage } from "../session";
export const getSessionMasterId = async () => {
  const masterId = await getSessionStorage("masterId");
  return masterId;
};
